import React from "react";
import { Box, styled } from "@mui/material";
import { QuirkIcon } from "../../icons/QuirkIcon";
import { PerkIcon } from "../../icons/PerkIcon";
import { LikeIcon } from "../../icons/LikeIcon";
import { DislikeIcon } from "../../icons/DislikeIcon";
import { perkQuirkLikeLabel, perkQuirkDislikeLabel } from "./util";
import type { PerkQuirkSentimentRecord } from "../../../types";

interface SmallPerkCardItem {
  id: string;
  name: string;
  type: "perk" | "quirk";
}

interface SmallPerkCardProps {
  item: SmallPerkCardItem;
  sentiments?: PerkQuirkSentimentRecord[];
}

const ItemCard = styled(Box, {
  label: "PerkQuirkSmallItemCard",
})(({ theme }) => ({
  borderRadius: theme.spacing(3),
  backgroundColor: "#fff",
  position: "relative",
  color: "#000",
  border: "1px solid #E5E7EB",
  display: "flex",
  width: 377,
  height: 187,
  padding: "20px 20px",
  flexDirection: "column",
  justifyContent: "flex-start",
  alignItems: "flex-start",
  gap: "16px",
}));

const ItemTitle = styled("div", {
  label: "PerkQuirkSmallItemTitle",
})(() => ({
  color: "#1C252E",
  fontFamily: "Proxima Nova",
  fontSize: "18px",
  fontStyle: "normal",
  fontWeight: "600",
  lineHeight: "28px",
  letterSpacing: "0px",
  display: "block",
  height: 85,
  minHeight: 85,
  flex: 0,
}));

const Rating = styled(Box, {
  label: "PerkQuirkSmallRating",
})(() => ({
  color: "var(--primary-main, #078dee)",
  fontSize: "16px",
  fontFamily: "Proxima Nova",
  fontWeight: "bold",
  lineHeight: "24px",
  wordWrap: "break-word",
  display: "flex",
  textTransform: "uppercase",
  alignItems: "center",
  justifyContent: "center",
  gap: "8px",
}));

export const SmallPerkCard = ({
  item,
  sentiments = [],
}: SmallPerkCardProps) => {
  const currentSentiment = sentiments.find(
    (s) => String(s.perksQuirksId) === String(item.id),
  );

  const forMe = currentSentiment?.sentiment === "LIKE";

  return (
    <ItemCard>
      <Rating>
        {forMe ? <LikeIcon /> : <DislikeIcon />}
        {forMe
          ? perkQuirkLikeLabel(item.type)
          : perkQuirkDislikeLabel(item.type)}
      </Rating>
      <ItemTitle>{item.name}</ItemTitle>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          width: "100%",
          justifyContent: "flex-end",
          position: "absolute",
          bottom: 10,
          right: 20,
        }}
      >
        {item.type === "perk" ? (
          <PerkIcon width={32} height={32} />
        ) : (
          <QuirkIcon width={32} height={32} />
        )}
      </Box>
    </ItemCard>
  );
};
